import styled from "styled-components";

export const ConsoleCampaignTemplateTableContainer = styled.div`
  @media (max-width: 650px) {
    div[data-field="channels"] {
      display: none;
    }
  }

  div[data-field="dots-icon"] {
    max-width: 40px !important;
  }

  svg * {
    fill: ${({ theme }) => theme.console.pageSubtitleColor};
  }
`;
